module.exports = "<img *ngIf=\"_avatarPath\" class=\"circle\" [ngClass]=\"[size, border]\" [src]=\"_avatarPath\">\r\n\r\n<div *ngIf=\"!_avatarPath\" class=\"flex-horizontal circle-small justify-content-center\" [ngClass]=\"[color, size, nonAvatarBorder]\">\r\n  <span class=\"white align-center\">{{ (initial ? initial[0] : 'C') | uppercase }}</span>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/common/user-avatar/user-avatar.html
// module id = ../../../../../src/app/components/common/user-avatar/user-avatar.html
// module chunks = 0